import axios from 'axios';
import { v4 as uuidv4 } from "uuid";
import { Md5 } from "ts-md5";
import { Notify } from 'vant';

//----------------封装 http
const $http = axios.create({
    baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
//  baseURL: 'http://168.192.0.123',
    withCredentials: true, //
    timeout: 6000, // 请求超时时间
    // 超时时间
    headers: {
        // 设置后端需要的传参类型
        'content-type': 'application/json; charset=utf-8',
        // "Lux-mateApiNonce": uuid, //每次调取接口生成的uuid
        // "Lux-mateApiSignature": mateApi, //md5(method+requestURI+nonce+timestamp+appId+appSecret)
        // "Lux-mateApiTimestamp": timestamp, // 每次调取接口的时间戳（秒级）
    },
})
//---------------- 错误处理函数
const err = (error) => {
    console.log("error data:")
    console.log(error)
     if (error.response) {
        const data = error.response.data
        // const token = Vue.ls.get(ACCESS_TOKEN)
        if (error.response.status === 403) {
            Notify({type: 'danger', message: data.message || data.msg});
        }
        if (error.response.status === 401) {
            Notify({type: 'danger', message: '你没有权限。'});
            // if (token) {
            //     setTimeout(() => {
            //         window.location.reload()
            //     }, 1500)
            // }
        }
        if (error.response.status === 404) {
            Notify({type: 'danger', message: '地址错误'});
            // if (token) {
            //     setTimeout(() => {
            //         window.location.reload()
            //     }, 1500)
            // }
        }
    }

    return Promise.reject(error)
}
//---------------- http interceptor(请求拦截器)
$http.interceptors.request.use(config => {
    const timestamp = parseInt(Date.now() / 1000);
    const uuid =  uuidv4(); // 生成UUID
    let signStr =config.method + config.url + uuid + timestamp + "Herdsric" + "2025"
    let mateApi = Md5.hashStr(signStr.toUpperCase());
    config.headers['ApiTimestamp'] = timestamp// 每次调取接口的时间戳（秒级）
    config.headers['ApiNonce'] = uuid //每次调取接口生成的uuid
    config.headers['ApiSignature'] = mateApi
    config.headers = config.headers || {};
    if (localStorage.getItem("token")) {
        config.headers.token = localStorage.getItem("token") || "";
    }
  //  config.url="public/"+config.url; //增加前缀
    return config
}, err)

//---------------- http interceptor（接收拦截器）
$http.interceptors.response.use((response) => {
     if (response.status!== 200 ||response.data=='') {
        Notify({type: 'danger', message: '网络繁忙,请稍后再试...'});
        return Promise.reject(response);
    } else {
        return response.data
    }
}, err)
export default $http;
/*

axios.post('https://jsonplaceholder.typicode.com/posts', {
    title: 'foo',
    body: 'bar',
    userId: 1
})
    .then(function (response) {
        console.log(response.data);
    })
    .catch(function (error) {
        console.log(error);
    });


axios.put('/api/users/1',
    { name: 'Lucy', age: 18 },  //请求的数据
    {
        headers: { 'X-Requested-With': 'XMLHttpRequest' } //请求头，添加自定义信息
    })
    .then(response => {
        console.log(response.data);
    })
    .catch(error => {
        console.log(error);
    });



axios.delete('/api/users/1')
    .then(response => {
        console.log(response.data);
    })
    .catch(error => {
        console.log(error);
    });



*/
